import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../context";
import { useActaDetalleStore } from "../store/actaDetalleStore";

const useShowOpciones = () => {
  const { actions } = useContext(UserContext);
  const { actaDetalle, acta } = useActaDetalleStore();
  // const { acta } = actaDetalle;
  const location = useLocation();

  let opciones = [];
  if (
    location.pathname == "/buscar-acta" &&
    (actions.hasPermission("JP") || actions.hasRole("admin") || actions.hasRole("147")) &&
    acta.estado_id != 13 &&
    acta.estado_id != 15
  ) {
    opciones.push({
      label: "Recibo",
      modal: "modal_recibo",
      className: "recibo",
    });
  }

  if (actions.hasPermission("JP") && acta.estado_id == 9 && acta.domicilio_notificacion_id) {
    opciones.push({
      label: "Notificar digital",
      modal: "modal_notificar_digital",
      className: "opciones-notificar-digital",
    });
  }
  if (actions.hasRole("tribunales") && [10, 8, 9].includes(acta.estado_id)) {
    opciones.push({
      label: "Notificar ",
      modal: "modal_notificar_acta",
      className: "opciones-notificar-digital",
    });
  }

  if (acta.estado_id == 3 && actions.hasPermission("actas.opciones.chequear")) {
    opciones.push({
      label: "Incompleta",
      modal: "incompleta_acta_detalle",
      className: "opcion-acta-incompleta",
    });

    if (acta.alertas.length == 0) {
      opciones.push({
        label: "Aprobar",
        modal: "aprobada_imprimir",
        className: "opcion-aprobar",
      });
    }
  }

  if (acta.estado_id == 7 && actions.hasPermission("actas.opciones.incompletas")) {
    opciones.push({
      label: "Completar",
      modal: "editar_acta",
      className: "opcion-completar-datos",
    });

    // opciones.push({

    //     label: "Completar",
    //     modal: "completar_datos",
    //     className: "opcion-completar-datos",
    // });
  }

  if (acta.estado_id == 10 && actions.hasPermission("actas.opciones.aprobadas")) {
    if (!acta.fecha_impresion) {
      opciones.push({
        label: "Impresa",
        modal: "impresa_acta_detalle",
        fecha_impresion: true,
        variant: "success",
        className: "opcion-acta-impresa",
      });
    }
  }
  if (acta.estado_id == 10 && actions.hasPermission("actas.opciones.incompletas")) {
    opciones.push({
      label: "Incompleta",
      modal: "incompleta_acta_detalle",
      className: "opcion-acta-incompleta",
    });
  }

  if (acta.estado_id == 2 && actions.hasPermission("actas.opciones.asignar")) {
    if (acta.fecha_impresion) {
      opciones.push({
        label: "Asignar",
        modal: "notificadores",
        className: "opcion-asignar-notificador",
      });
    }
  }

  if (acta.estado_id == 8 && actions.hasPermission("actas.opciones.reparto")) {
    if (acta.notificador) {
      opciones.push({
        label: "Desasignar",
        modal: "desasignar_notificador",
        className: "opcion-acta-incompleta",
      });
    }
  }

  if (acta.estado_id == 9 && actions.hasPermission("actas.opciones.reasignar")) {
    opciones.push({
      label: "Reasignar",
      modal: "reasignar_notificador",
      className: "opcion-acta-incompleta",
    });

    if (actions.hasPermission("actas.noAprobar")) {
      opciones.push({
        label: "Incompleta",
        modal: "incompleta_acta_detalle",
        className: "opcion-acta-incompleta",
      });
    }
  }

  if (
    actions.hasPermission("actas.opciones.notificadas") &&
    actions.hasPermission("actas.descargo") &&
    (acta.estado_id == 4 || acta.estado_id == 11)
  ) {
    opciones.push({
      label: "Descargo",
      modal: "descargo",
      className: "opcion-asignar-descargo",
    });
  }
  // console.log(actions.hasPermission('actas.opciones.constancia'))
  if (
    /* (acta.estado_id == 4 || acta.estado_id == 11 ) && */ actions.hasPermission(
    "actas.opciones.constancia"
  ) &&
    acta.fecha_notificacion &&
    acta.tipo_acta_generada == "DIGITAL"
  ) {
    opciones.push({
      type: "buscar_acta",
      label: "Constancia",
      modal: "constancia",
      className: "opcion-asignar-descargo",
    });
  }

  if (
    actions.hasPermission("actas.anular") &&
    acta.estado_id != 4 &&
    acta.estado_id != 11 &&
    acta.estado_id != 12 &&
    acta.estado_id != 15
  ) {
    opciones.push({
      label: "Anular",
      modal: "modal_confirm",
      className: "opcion-asignar-descargo",
    });
  }

  if (actions.hasRole("admin")) {
    opciones.push({
      label: "Auditar",
      modal: "auditar_acta",
      className: "opcion-auditar-acta",
    });
  }

  if (actions.hasRole("tribunales") && acta.estado_id == 15) {
    opciones.push({
      label: "Baja tribunal",
      modal: "baja_tribunal",
      className: "opcion-baja-tribunal",
    });
  }

  if ((actions.hasPermission("JP") || actions.hasRole("admin.app")) && acta.estado_id == 12) {
    opciones.push({
      label: "Constancia anulación",
      modal: "constancia_anulacion",
      className: "opcion-aprobar",
    });
  }

  // const opcionesClean =Array.from(new Set(opciones.map(obj => JSON.stringify(obj))))
  // .map(str => JSON.parse(str));

  // console.log(opcionesClean)

  return opciones;
};

export default useShowOpciones;
